import React, {
  useState,
  useEffect,
  memo,
  useCallback,
  useRef,
} from "react";
import classNames from "classnames/bind";
import {
  Col,
  Row,
  Pagination,
  Skeleton,
  Toast,
  Clock,
} from "../../../../components";
import {
  MenuIcon,
  FullVideo,
  OffStatus,
  OnStatusGreen,
  WeakStatus,
} from "../../../../components/Icons/Icons";
import { CameraContext } from "../../LiveCamera";
import image2 from "../../../../assets/images/Offcamera.jpg";
import image2En from "../../../../assets/images/Offcamera-en.png";
import image1 from "../../../../assets/images/NoConnect.png";
import image1En from "../../../../assets/images/NoConnect-en.png";
import streamingClient from "../../../../services/streamingClient";
import SettingCamera from "./SettingCamera";
import { limitChangePoint, playManySounds, swapArr } from "../../../../utils";
import SearchFail from "../../../Location/SearchFaild/SearchFail";
import styles from "./StreamCam.module.css";
import { groupCameraManagement } from "../../../../services/api/GroupCameraManagement";
import PlayerItem from "./PlayerItem";
import { useTranslation } from "react-i18next";
import { ScreenShot } from "../../../../components/Icons/Stream/ScreenShot";
import { useScreenshot, createFileName } from "use-react-screenshot";
import axiosClient from "../../../../services/axiosClient";
import OneCameraFullScreen from "./OneCameraFullScreen";
import { fontSize } from "./ConfigFontSize";

const cx = classNames.bind(styles);
const StreamCam = ({
  streaming,
  page,
  getCodeInfo,
  getCodeSetting,
  filter,
  setTotal,
  onShowRename,
  setNameCamera,
}) => {
  const {
    isLoadingCamera,
    isOneCameraFullScreen,
    listCamera,
    setListCamera,
    handleFullScreen,
    cameraActive,
    showTaskbar,
    screen,
    isFullScreen,
    setCurrentPage,
    currentPage,
    groupCode,
    isGroup,
    setIsOneCameraFullScreen,
    isSearchCam,
    setIsSearchCam,
    screenSearch,
    setRefreshPath,
  } = React.useContext(CameraContext);
  const [show, setShow] = useState(false);
  const [code, setCode] = useState();
  const [draggedItem, setDraggedItem] = useState();
  const [refresh, setRefresh] = useState(false);
  const [name, setName] = useState("");
  const [reload, setReload] = useState(false);
  const companyCode = sessionStorage.getItem("company_code");
  const [listCameraFilter, setListCameraFilter] = useState([]);
  const [newEvent, setNewEvent] = useState([]);
  const [camera, setCamera] = useState([]);
  const [scale, setScale] = useState(1);
  const [cameraFocus, setCameraFocus] = useState("");
  const [panning, setPanning] = useState(false);
  const [point, setPoint] = useState({
    x: 0,
    y: 0,
  });
  const [keepTimeCamera, setKeepTimeCamera] = useState([]);
  const [sizeElement, setSizeElement] = useState({
    width: 0,
    height: 0,
  });
  const [pointX, setPointX] = useState(0);
  const [pointY, setPointY] = useState(0);
  const screens = isSearchCam ? screenSearch : screen;
  const [hikEvent, setHikEvent] = useState([]);
  const [autoScreenCaption, setAutoScreenCaption] = useState(false);
  const { t } = useTranslation();
  const refFullScreen = useRef(null);
  const [image, takeScreenShot] = useScreenshot({
    type: "image/jpeg",
    quality: 1.0,
  });
  const [countCarPark, setCountCarPark] = useState();
  const [refreshCamera, setRefreshCamera] = useState(false);
  let classNameCamerName = isFullScreen ? "font-size-name-Fs-" : 'font-size-name-';

  const handleWheel = (e) => {
    e.preventDefault();
    const deltaY = e.deltaY || e.detail || e.wheelDelta;
    const direction = deltaY > 0 ? -1 : 1;
    setScale((prevScale) => prevScale + direction * 0.1);
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [screen, screenSearch]);
  useEffect(() => {
    const data = [
      ...listCamera,
    ].filter(
      (item, index) =>
        index + 1 > (currentPage - 1) * screens.total &&
        index + 1 <= screens.total * currentPage
    );
    setListCameraFilter(data);
  }, [currentPage, listCamera, isSearchCam, screens]);
  useEffect(() => {
    const data =
      !filter.notConnect && !filter.off && !filter.on && !filter.weak
        ? streaming
        : streaming.filter(
          (item) =>
            (filter.on && item.status === "On") |
            (filter.off && item.status === "Off") |
            (filter.weak | filter.notConnect && item.status === "Weak")
        );

    setTotal(data.length);
    setListCamera([...data]);
  }, [streaming, filter]);

  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      const eventSource = new EventSource(
        `${process.env.REACT_APP_SSE_LIVE
        }notification-sse/?token=${sessionStorage.getItem("token")}`
      );
      eventSource.onmessage = (event) => {
        const aiEvent = JSON.parse(event.data);
        // riêng báo cháy để delay 15s để nó sát với real time
        if (aiEvent && aiEvent?.type_notification_code === "CODE_11") {
          setTimeout(() => {
            setNewEvent([
              {
                code: aiEvent.camera_code,
                time: Date.now(),
                name: aiEvent.camera_name,
                is_zoom: aiEvent.is_zoom,
                sound_path: aiEvent.sound_path[0],
                is_voice: aiEvent.is_voice,
                type_notification_code: aiEvent.type_notification_code,
                sound_ai_path: aiEvent?.sound_ai_path,
                color: aiEvent?.color,
                ...aiEvent
              },
            ]);
          }, 15 * 1000);
        }
        // Với phát hiện chuyển động sẽ có cảnh báo real time không có ai_path thì bỏ qua vì nó nhanh hơn trên web khoảng 30, 40s
        else if (
          aiEvent &&
          aiEvent?.type_notification_code === "CODE_7" &&
          aiEvent?.ai_path === ""
        ) {
          // console.log('next event');
          return;
        } else {
          setNewEvent([
            {
              code: aiEvent.camera_code,
              time: Date.now(),
              name: aiEvent.camera_name,
              is_zoom: aiEvent.is_zoom,
              sound_path: aiEvent?.type_notification_code === "CODE_8" ? aiEvent.sound_path : aiEvent.sound_path[0],
              is_voice: aiEvent.is_voice,
              type_notification_code: aiEvent.type_notification_code,
              sound_ai_path: aiEvent?.sound_ai_path,
              color: aiEvent?.color,
              object: aiEvent?.object_type || aiEvent?.id_object,
              info: aiEvent?.license_plate_text || aiEvent?.name_object,
              image: aiEvent?.license_plate_image_path || aiEvent?.small_img_path || aiEvent?.ai_path,
              object_detail: aiEvent?.object_detail || null,
              ...aiEvent
            },
          ]);
        }
      };
      eventSource.onerror = (error) => {
        // console.log("Lỗi");
        eventSource.close();
      };
      return () => {
        eventSource.close();
      };
    }
  }, []);
  // Lấy nhiệt độ real time
  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      const eventSource = new EventSource(
        `${process.env.REACT_APP_SSE_LIVE
        }temperature-hik-sse/?token=${sessionStorage.getItem("token")}`
      );
      eventSource.onmessage = (event) => {
        setHikEvent([
          {
            camera_code: JSON.parse(event.data)?.camera_code,
            temperature: JSON.parse(event.data)?.temperature,
          },
        ]);
      };
      eventSource.onerror = (error) => {
        // console.log("Lỗi");
        eventSource.close();
      };
      return () => {
        eventSource.close();
      };
    }
  }, []);
  useEffect(() => {
    if (newEvent.length > 0) {
      if (listCameraFilter.some((item) => item.code === newEvent[0]?.code)) {
        const camera = keepTimeCamera.filter(
          (item) => item.camera_code === newEvent[0]?.code
        );
        if (camera.length > 0) {
          let audio = new Audio(
            `${process.env.REACT_APP_BASE_URL}staticfile/${newEvent[0]?.sound_ai_path}`
          );
          // âm thanh cảnh báo trước sự kiện
          let soundAi = new Audio(
            `${process.env.REACT_APP_BASE_URL}${newEvent[0]?.sound_path}`
          );
          if (newEvent[0]?.is_voice === 1) {
            // Với sự kiện Phát hiện xâm nhập chỉ cần phát âm thanh soud_path vì nó được trả ra danh sách âm thanh cho từng đối tượng
            if (newEvent[0]?.type_notification_code === "CODE_8") {
              playManySounds(newEvent[0]?.sound_path);
            } else {
              soundAi.play();
              audio.play();
            }
          }
          if (Date.now() - camera[0].time > 5 * 60 * 1000) {
            const newData = keepTimeCamera.filter(
              (item) => item.camera_code !== newEvent[0]?.code
            );
            setKeepTimeCamera([
              ...newData,
              {
                camera_code: newEvent[0]?.code,
                time: Date.now(),
              },
            ]);

            if (newEvent[0]?.is_zoom === 1) {
              handleFull(newEvent[0]?.name, "full");
            }
          }
        } else {
          setKeepTimeCamera([
            ...keepTimeCamera,
            {
              camera_code: newEvent[0]?.code,
              time: Date.now(),
            },
          ]);
          let audio = new Audio(
            `${process.env.REACT_APP_BASE_URL}${newEvent[0]?.sound_path}`
          );
          if (newEvent[0]?.is_voice === 1) {
            audio.play();
          }
          if (newEvent[0]?.is_zoom === 1) {
            handleFull(newEvent[0]?.name, "full");
          }
        }
      }
      const data = camera.filter((item) => item !== newEvent[0]?.code);
      const filterTime = data.filter((item) => Date.now() - item.time < 10000);

      setCamera([...filterTime, ...newEvent]);
    }
  }, [newEvent]);

  // // console.log(streaming);
  useEffect(() => {
    const data = setInterval(() => {
      setCamera([]);
    }, 10000);
    return () => {
      clearInterval(data);
    };
  }, [camera]);
  const showOptions = (value) => {
    if (!isSearchCam) {
      streaming.map((item) => {
        if (value === item?.code) {
          setShow(!show);
          setCode(value);
        }
        return item;
      });
    } else {
      setShow(true);
      setCode(value);
    }
  };
  const savePositionCam = useCallback(
    async (arr) => {
      let position = arr?.map((cam, index) => {
        return {
          camera_code: cam.code,
          seq: index,
        };
      });
      let data = {
        list_group_cam: {
          data: position,
        },
      };
      try {
        await groupCameraManagement.changeSeq(data, groupCode);
      } catch (error) {
        console.error("We can't save position");
      }
    },
    [groupCode]
  );
  const onDragStart = (e, item) => {
    setDraggedItem(item);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.target.parentNode);
    e.dataTransfer.setDragImage(e.target.parentNode, 20, 20);
  };
  const onDragOver = (e, index) => {
    if (isGroup) {
      e.preventDefault();
      if (draggedItem) {
        if (draggedItem.code === index.code) {
          return;
        }
        const arr2 = swapArr(listCamera, draggedItem, index);
        const arr = swapArr(listCameraFilter, draggedItem, index);
        setListCameraFilter(arr);
        savePositionCam(arr2);
        setCamera([]);
        Toast.open(t("stream.changePosotionSuccess"), "success");
      }
    } else {
      Toast.open(t("stream.changePosotionError"), "info");
    }
  };
  const handleFull = (name, type, code) => {
    if (isSearchCam) {
      setIsSearchCam(false);
    }
    handleFullScreen(name, listCamera, "FullScreen");
    if (type === "small") {
      setIsOneCameraFullScreen(false);
    }
    setShow(false);
    setName(name);
    if (code) {
      const data = camera.filter((item) => item.code !== code);
      setCamera(data);
    }
  };
  const showInfoCamera = (code) => {
    getCodeInfo(code);
    setShow(!show);
  };
  const showSettingModal = (code) => {
    getCodeSetting(code);
    setShow(!show);
  };
  useEffect(() => {
    const clickOutSideToClose = (e) => {
      if (e.target.localName !== "svg") {
        setShow(false);
      }
    };
    document.addEventListener("click", clickOutSideToClose);
    return () => {
      document.removeEventListener("click", clickOutSideToClose);
    };
  }, [show]);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };

  const restartCamera = async (code, showNoti = true) => {
    try {
      await streamingClient.post("/streamManagement/post-restart-streaming/", {
        camera_id: code,
      });
      showNoti && Toast.open(t("stream.restartCameraSuccess"), "success");
      setRefreshCamera(!refreshCamera)
    } catch (error) {
      Toast.open(t("stream.restartCameraError"), "danger");
    }
  };
  const onDragEnd = () => {
    setDraggedItem(null);
  };
  const handleMove = (e) => {
    if (scale !== 1) {
      e.preventDefault();
      setPoint({
        x: e.clientX - pointX,
        y: e.clientY - pointY,
      });
      setPanning(true);
    }
  };
  const handleUp = (e) => {
    setPanning(false);
  };
  const handleBackButtonEvent = useCallback(
    (e) => {
      handleFull(name);
    },
    [name]
  );

  useEffect(() => {
    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("popstate", handleBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", handleBackButtonEvent);
    };
  }, [handleBackButtonEvent]);
  const download = (
    image,
    { name = "VNS-CameraAI-Screenshot", extension = "png" } = {}
  ) => {
    try {
      const a = document.createElement("a");
      a.href = image;
      a.download = createFileName(extension, name);
      a.click();
      handleFull("", "small", "");
      setAutoScreenCaption(false);
    } catch (error) {
      Toast.open("Chụp màn hình cam không thành công", "danger");
      handleFull("", "small", "");
      setAutoScreenCaption(false);
    }
  };

  const handleScreenShot = (name, option, code, element) => {
    handleFull(name, option, code);
    const cameraSelect = listCameraFilter?.find(item => item?.code === code);
    const url = cameraSelect?.url;
    fetch(url).then(
      setTimeout(() => {
        setAutoScreenCaption(true);
      }, 5 * 1000)
    ).catch(() => {
      throw new Error('Network error')
    });
  };

  const handleReFreshAI = async (code, alert) => {
    try {
      setRefreshPath((prev) => !prev)
      const camerasRefresh = {
        list_camera: {
          data: [
            {
              camera_code: code,
            },
          ],
        },
      };
      const res = await axiosClient.post(
        "aiConfig/post-get-update-ai-config/",
        camerasRefresh
      );
      if (res) {
        const updateAi = listCameraFilter?.map((item) => {
          const newInfo = res?.list_cam_ai_config?.find(
            (cam) => cam?.code === item?.code
          );
          if (newInfo) {
            const listAiConfig = newInfo?.list_ai_config
              ?.filter((ai) => ai?.STATUS === 1)
              .map((ai) => {
                return {
                  ai_service_code: ai?.CODE,
                  ai_name: ai?.SUBJECT_NAME,
                  is_voice: ai?.IS_VOICE,
                  status: ai?.STATUS
                };
              });
            const listAiRegister = newInfo?.list_service_registered;
            const status =
              newInfo?.status_active === 3
                ? "Off"
                : newInfo?.status_active === 2 || newInfo?.status_active === 1
                  ? "Weak"
                  : "On";
            const is_VOICE = !!listAiConfig?.find((ai) => ai?.IS_VOICE === 1);

            return {
              ...item,
              list_ai_service: listAiConfig,
              list_ai_service_registed: listAiRegister,
              status: status,
              is_VOICE: is_VOICE,
            };
          } else {
            return item;
          }
        });
        setListCameraFilter(updateAi);
      }
      setRefreshCamera(!refreshCamera)
      alert && Toast.open("Làm mới thành công", "success");
    } catch (error) {
      alert && Toast.open("Làm mới không thành công", "danger");
      console.log(error);
    }
  };

  useEffect(() => {
    if (autoScreenCaption && refFullScreen.current) {
      const downloadScreenshot = () => takeScreenShot(refFullScreen.current).then(download);
      downloadScreenshot();
    }
  }, [autoScreenCaption, refFullScreen.current]);

  const propsOneCamera = {
    handleWheel, handleMove, handleUp, setPointX, setPointY, limitChangePoint, refFullScreen, screens, sizeElement,
    handleReFreshAI, scale, panning, camera, companyCode, handleFull, showOptions, pointX, pointY, reload, setReload,
    image1, hikEvent, show, code, showInfoCamera, showSettingModal, restartCamera, point, onShowRename, setNameCamera, setCountCarPark, countCarPark, refreshCamera
  }



  return (
    <>
      <div className={cx("live")}>
        <Row style={{ width: "100%", position: "relative" }} gap={[0, 0]}>
          {!isLoadingCamera ? (
            listCameraFilter.length > 0 ? (
              listCameraFilter.map((item, index) => {
                if (
                  item?.code &&
                  item?.url !==
                  `${process.env.REACT_APP_BASE_URL}livestreamno-path` &&
                  item.status === "On"
                ) {
                  return (
                    <Col
                      style={{ position: "relative", background: "black" }}
                      key={item?.code || index}
                      span={12 / screens.col}
                      onDrop={(e) => {
                        onDragOver(e, item);
                      }}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      <div
                        draggable
                        onDragStart={(e) => {
                          onDragStart(e, item);
                        }}
                        onDragEnd={(e) => {
                          onDragEnd(item);
                        }}
                        style={{
                          cursor: "all-scroll",
                        }}
                        className={cx("contain")}
                        onWheel={handleWheel}
                        onMouseDown={(e) => handleMove(e)}
                        onMouseUp={(e) => handleUp(e)}
                        onMouseMove={(e) => {
                          if (cameraFocus !== item.code) {
                            setSizeElement({
                              width: e.target.getBoundingClientRect().width,
                              height: e.target.getBoundingClientRect().height,
                            });
                            setCameraFocus(item.code);
                            setScale(1);
                            setPointX(0);
                            setPointY(0);
                          }
                          if (scale !== 1) {
                            if (!panning) {
                              return;
                            }
                            setPointX(
                              limitChangePoint(
                                e.clientX - point.x,
                                e.target.getBoundingClientRect().width -
                                sizeElement.width
                              )
                            );

                            setPointY(
                              limitChangePoint(
                                e.clientY - point.y,
                                e.target.getBoundingClientRect().height -
                                sizeElement.height
                              )
                            );
                          }
                        }}
                      >
                        <PlayerItem
                          item={item}
                          screen={screens}
                          handleFullScreen={handleFull}
                          showOptions={showOptions}
                          isOneCameraFullScreen={isOneCameraFullScreen}
                          nfc={camera}
                          scale={scale}
                          cameraFocus={cameraFocus}
                          pointX={pointX}
                          pointY={pointY}
                          restartCamera={handleReFreshAI}
                          isFullScreen={isFullScreen}
                          hikEvent={hikEvent}
                          getCountCarPark={(count) => setCountCarPark(count)}
                          refreshCamera={refreshCamera}
                        />

                        {!isOneCameraFullScreen && (
                          <SettingCamera
                            show={show}
                            item={item}
                            code={code}
                            refresh={refresh}
                            showInfoCamera={showInfoCamera}
                            showSettingModal={showSettingModal}
                            restartCamera={restartCamera}
                            onShowRename={onShowRename}
                            setNameCamera={setNameCamera}
                            isSearchCam={isSearchCam}
                            reFreshCamera={handleReFreshAI}
                          />
                        )}
                        <div
                          className={cx("btn-screen-shot")}
                          onClick={() =>
                            handleScreenShot(
                              item?.name,
                              "",
                              item?.code,
                              refFullScreen
                            )
                          }
                        >
                          <ScreenShot />
                        </div>
                      </div>
                    </Col>
                  );
                } else {
                  return (
                    <Col
                      style={{ position: "relative" }}
                      span={12 / screens.col}
                      key={index}
                      onDrop={(e) => onDragOver(e, item)}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      <div
                        draggable
                        onDragStart={(e) => onDragStart(e, item)}
                        onDragEnd={(e) => onDragEnd(item)}
                        style={{ cursor: "all-scroll" }}
                        className={cx("contain")}
                      >
                        <div className={cx("full-video")}></div>
                        <div className={cx("setting")}>
                          <div className={cx("name_status")}>
                            {companyCode === "DEFAULT" ? (
                              <span className={cx("On")}>
                                {item?.status === "Off" ? (
                                  <OffStatus />
                                ) : item?.status === "Off" ? (
                                  <OnStatusGreen />
                                ) : (
                                  <WeakStatus />
                                )}
                              </span>
                            ) : (
                              <span className={cx("On")}>
                                <OffStatus />
                              </span>
                            )}

                            <span
                              style={{ fontSize: 12, maxWidth: "100%" }}
                              className={cx("name", `${classNameCamerName}${screen?.total}`)}
                            >
                              {item?.name}
                            </span>
                          </div>
                          <div className={cx("icon")} style={{ width: "100%" }}>
                            <span onClick={(e) => handleFull(item?.name)}>
                              <FullVideo />
                            </span>
                            <span
                              className={cx("menu")}
                              onClick={(e) => showOptions(item?.code)}
                            >
                              <MenuIcon />
                            </span>
                          </div>
                        </div>
                        <img
                          src={
                            item?.status === "Off"
                              ? localStorage?.getItem("laguage") === "en"
                                ? image2En
                                : image2
                              : localStorage?.getItem("laguage") === "en"
                                ? image1En
                                : image1
                          }
                          alt={"sub"}
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            display: "block"
                          }}
                        />
                        <div className={cx("footer")}>
                          <div className={cx("icon")} style={{ width: "100%" }}>
                            <Clock fontSize={isFullScreen ? fontSize?.find(size => size?.screen === screen?.total)?.sizeFs : fontSize?.find(size => size?.screen === screen?.total)?.size} />
                          </div>
                        </div>
                        <SettingCamera
                          show={show}
                          item={item}
                          code={code}
                          showInfoCamera={showInfoCamera}
                          showSettingModal={showSettingModal}
                          restartCamera={restartCamera}
                          onShowRename={onShowRename}
                          setNameCamera={setNameCamera}
                          reFreshCamera={handleReFreshAI}
                        />
                      </div>
                    </Col>
                  );
                }
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <SearchFail />
              </div>
            )
          ) : (
            <Col style={{ height: "100%" }}>
              <Skeleton
                borderRadius={4}
                height={isFullScreen ? "100vh" : "540px"}
              />
            </Col>
          )}
        </Row>
      </div>
      {isOneCameraFullScreen && (
        <OneCameraFullScreen
          {...propsOneCamera}
        />
      )}
      <div
        className={cx("pagination", isFullScreen ? "full" : "")}
        style={isFullScreen ? (showTaskbar ? {} : { display: "none" }) : {}}
      >
        {!isLoadingCamera ? (
          listCamera.length > 0 &&
          !isSearchCam && (
            <Pagination
              onClick={handleClick}
              onNext={handleNext}
              onPrevious={handlePrevious}
              bgColor="rgba(255, 255, 255, 0.15)"
              pages={page}
              currentPage={currentPage}
              isFullScreen={isFullScreen}
            />
          )
        ) : (
          <Skeleton width="100px" height="40px" borderRadius={10} />
        )}
      </div>
    </>
  );
};

export default memo(StreamCam);
